import { render, staticRenderFns } from "./HistoryPackages.vue?vue&type=template&id=212538cb&"
import script from "./HistoryPackages.vue?vue&type=script&lang=js&"
export * from "./HistoryPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports